import {h} from "preact";
import { DateTime } from "luxon";
import {forwardRef, useMemo} from "preact/compat";
import { useQuery } from "@urql/preact";
import "./Catchup.scss";
import { useEffectEveryHourOnTheHour } from "../../lib/useEffectEveryHourOnTheHour";

const PastShowsQuery = `
    query {
        previousTimeslots(n: 6){
            itemId
            title
            description
            uploadState
            startTime
            endTime
            photo
            webpage
        }
        currentTimeslot {
            itemId
        }
    }
`;

interface ShowInfo {
    itemId: number;
    title: string;
    description: string;
    uploadState: string | null;
    startTime: string;
    endTime: string;
    photo: string | null;
    webpage: string;
}

function Show({show}: { show: ShowInfo }) {
    const startFmt = useMemo(() => {
        const time = DateTime.fromISO(show.startTime);
        const now = DateTime.local();
        return time.toLocaleString(
            time.day === now.day ? DateTime.TIME_24_SIMPLE : DateTime.DATETIME_SHORT
        );
    }, [show.startTime]);
    const endFmt = useMemo(() => {
        const time = DateTime.fromISO(show.endTime);
        const start = DateTime.fromISO(show.startTime);
        const diff = time.diff(start, "days").toObject().days
        return time.toLocaleString(
            diff < 1 ? DateTime.TIME_24_SIMPLE : DateTime.DATETIME_SHORT
        );
    }, [show.endTime, show.startTime]);
    return (
        <div class={"show" + ("webpage" in show ? " link" : "")} onClick={() => "webpage" in show ? window.open("https://ury.org.uk" + show.webpage, "_blank") : ""}>
            {show.photo && <img src={"https://ury.org.uk" + show.photo} alt={`Show photo for ${show.title}`} />}
            <div className="info">
                <h5>{show.title}</h5>
                <em>{startFmt} - {endFmt}</em>
                {show.uploadState && show.uploadState.includes("URY1350") && (
                    <span class="listen-btn"><a className="btn" href={"https://ury.org.uk" + show.webpage} target="_blank">Listen Back</a></span>
                )}
            </div>
        </div>
    );
}

const Catchup = forwardRef<HTMLDivElement>((props, ref) => {
    const [result, refetch] = useQuery({
        query: PastShowsQuery,
        requestPolicy: 'network-only'
    });
    useEffectEveryHourOnTheHour(refetch);
    return (
        <div class="catchup-card card" ref={ref}>
            <a href="https://ury.org.uk/ontap" target="_blank" title="Go to URY's Catchup Service, URY On Tap.">
                <h2 class="header-sideline">
                    <span class="btn header">
                        Catch Up
                    </span>
                    <span class="sideline">with URY On Tap</span>
                </h2>
            </a>
            <p class="showDesc"><strong>URY On Tap</strong> has got hundreds of shows for you to listen back to, insightful podcasts to discover and great videos
            to enjoy!</p>
            <h3>Recent Shows...</h3>
            <div class="catchup-list">
                {result.data &&
                result.data.previousTimeslots
                    ?.filter((x: any) => (result.data.currentTimeslot && result.data.currentTimeslot.itemId !== x.itemId) || !result.data.currentTimeslot)
                    .map((show: ShowInfo) => <Show key={show.itemId} show={show} />)}
            </div>
        </div>
    )
});
export default Catchup;
